'use es6';

import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { record } from 'react-immutable-proptypes';
import { getTableLabel } from '../../../../utils/table-utils';
import { useTableSource } from '../SourceMeta';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpanContainer = styled.div.withConfig({
  displayName: "DeletedStagedPropertyFilterLabel__StyledSpanContainer",
  componentId: "sc-2p648h-0"
})(["display:block;font-weight:600;margin-bottom:-4px;"]);
const DeletedStagedPropertyFilterLabel = ({
  propertyFilterRef
}) => {
  const {
    table: tableName,
    property: propertyName
  } = propertyFilterRef;
  const tableSource = useTableSource(tableName);
  const tableLabel = getTableLabel(tableName, tableSource);
  const errorMessage = I18n.text('reporting-snowflake.metadata-errors.invalid-property');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledSpanContainer, {
      children: /*#__PURE__*/_jsx(Text, {
        children: tableLabel
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: errorMessage,
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-alert-default",
        children: /*#__PURE__*/_jsx(Text, {
          children: propertyName
        })
      })
    })]
  });
};
DeletedStagedPropertyFilterLabel.propTypes = {
  /**
   * instance of <PropertyFilterRef>
   */
  propertyFilterRef: record.isRequired
};
export default DeletedStagedPropertyFilterLabel;